import { FormattedMessage } from 'react-intl';

import { UserBalance } from 'components/wallet/UserBalance';
import { useCryptoBalance } from 'hooks/useCryptoBalance';
import { payment } from 'lib/glossary';

import { CryptoWalletIcon } from '../Icon/CryptoWalletIcon';
import { SorareWallet } from '../SorareWallet';

type Props = {
  withoutBalance?: boolean;
};

export const CryptoWallet = ({ withoutBalance }: Props) => {
  const { cryptocurrencySymbol } = useCryptoBalance();
  return (
    <SorareWallet
      icon={<CryptoWalletIcon />}
      label={
        <FormattedMessage
          {...payment.sorareCryptoWallet}
          values={{ cryptocurrencySymbol }}
        />
      }
      balance={<UserBalance inline disableToggle />}
      withoutBalance={withoutBalance}
    />
  );
};
